import * as React from 'react'
import { tw } from 'utils/classnames'
import { CurrencyCode } from 'codegen/types'
import { useLocale } from 'next-intl'
import { useCurrentCurrency } from '@repo/cf-user/hooks/use-current-currency'

export function usePrice({
  value,
  currency = CurrencyCode.Usd,
  noDecimalZeros,
}: {
  value?: number | string
  currency?: CurrencyCode
  noDecimalZeros?: boolean
}) {
  if (value !== undefined) {
    const maximumFractionDigits = Number.isInteger(Number(value)) && noDecimalZeros ? 0 : 2

    return new Intl.NumberFormat('en', {
      style: 'currency',
      currency,
      minimumFractionDigits: maximumFractionDigits,
      maximumFractionDigits,
    }).format(Number(value))
  }
}

interface PriceProps {
  value?: number | string
  currency?: CurrencyCode
  crossed?: boolean
  noDecimalZeros?: boolean
  locale: string
  className?: string
}

const Price = ({
  value,
  currency = CurrencyCode.Usd,
  crossed,
  noDecimalZeros,
  className,
}: PriceProps) => {
  const price = usePrice({ value, currency, noDecimalZeros })

  if (!price) {
    return null
  }

  return <span className={tw(crossed && 'line-through', className)}>{price}</span>
}

export const LocalizedPrice = (props: Omit<PriceProps, 'currency' | 'locale'>) => {
  const locale = useLocale()
  const currency = useCurrentCurrency().code || CurrencyCode.Usd

  return <Price currency={currency} locale={locale} {...props} />
}
